import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Typo from 'constants/typography'
import { isSoldOut } from 'lib/utils/product'

const SelectorItem = ({
  attributes,
  selectedOption,
  onClick,
  isComingSoon,
}) => {
  const getClassName = (attr) => {
    const isSelected =
      selectedOption?.id_product_attribute === attr.id_product_attribute
    const className = clsx(
      Typo.button,
      'pdp__options-item',
      { active: isSelected },
      { fade: isSoldOut(attr) && !isComingSoon },
    )
    return className
  }

  return (
    <Fragment>
      {attributes.map((attr) => (
        <button
          key={attr.id_product_attribute}
          type="button"
          className={getClassName(attr)}
          onClick={() => onClick(attr)}
        >
          {attr.size}
        </button>
      ))}
    </Fragment>
  )
}

SelectorItem.defaultProps = {
  selectedOption: null,
  isComingSoon: false,
}

SelectorItem.propTypes = {
  attributes: PropTypes.arrayOf(
    PropTypes.shape({
      size: PropTypes.string,
    }),
  ).isRequired,
  selectedOption: PropTypes.shape({
    id_product_attribute: PropTypes.number,
  }),
  onClick: PropTypes.func.isRequired,
  isComingSoon: PropTypes.bool,
}

export default SelectorItem
